import { HttpError } from "@refinedev/core";
import { useTable } from "@refinedev/react-table";

import { DataTable } from "@/components/refine-ui/data-table/data-table";
import { DataTableActionBar } from "@/components/refine-ui/data-table/data-table-action-bar";
import { ListView } from "@/components/refine-ui/views/list-view";
import { useMovieColumns } from "@/pages/movies/hooks/use-columns";
import { IMovieData } from "@/types/movie";

export const MoviesList = () => {
  const columns = useMovieColumns();

  const table = useTable<IMovieData, HttpError>({
    columns,
    enableColumnResizing: true,
    columnResizeMode: "onChange",
    initialState: {
      columnVisibility: { id: false },
      columnPinning: { right: ["actions"] },
    },
    refineCoreProps: {
      meta: {
        // Movies have no `name` field; title/originalTitle are the searchable
        // fields (same as the movie search repository).
        defaultQueryBy: "title,originalTitle",
      },
      sorters: {
        initial: [{ field: "createdAt", order: "desc" }],
      },
      pagination: { pageSize: 25 },
    },
  });

  return (
    <ListView>
      <DataTableActionBar resource="movies" table={table} />
      <DataTable table={table} />
    </ListView>
  );
};
